import { useState } from "react";
import { createLanding, getLandingContent } from "./landing"; // Importa ambas funciones

export const useCreateLanding = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingCreate, setIsLoadingCreate] = useState(false);
  const [error, setError] = useState(null);
  const [errorCreate, setErrorCreate] = useState(null);
  const [response, setResponse] = useState(null);
  const [responseCreate, setResponseCreate] = useState(null);

  const handleCreateLanding = async (htmlString) => {
    try {
      setIsLoadingCreate(true);
      setErrorCreate(null);

      const responseData = await createLanding(htmlString);

      setResponseCreate(responseData);
    } catch (error) {
      setErrorCreate(error);
    } finally {
      setIsLoadingCreate(false);
    }
  };

  const fetchLandingContent = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const responseData = await getLandingContent();

      setResponse(responseData);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isLoadingCreate,
    error,
    errorCreate,
    response,
    responseCreate,
    handleCreateLanding,
    fetchLandingContent,
  };
};
